import { useEffect, useRef } from 'react';

const usePrevious = <T>(value: T): T | null | undefined => {
  const ref = useRef<any>(value);

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export default usePrevious;
